import template from './template.html'
import controller from './headline.controller'

export default {
  restrict: 'E',
  template,
  bindings: { storyObj: '<' },
  controller,
  controllerAs: 'vm',
}
